import React from 'react';
import { WebsiteImage } from 'components/TitleDescription';

import iconCalendar from '../../../../images/webinar-calendar.svg';
import iconTime from '../../../../images/webinar-time.svg';
import iconDuration from '../../../../images/webinar-duration.svg';

import { Container } from './styles';

const WebinarHeroInfoStrip = ({ date, time, duration }) => {
  const durationStr = (duration >= 60 ? `${Math.floor(duration / 60)}h` : '') + (duration % 60 > 0 ? ` ${duration % 60}m` : '');

  return (
    <Container>
      {date && 
        <div className="webinar-hero--info-strip-item">
          <div className="webinar-hero--info-strip-icon"><WebsiteImage src={iconCalendar} /></div>
          <p className="webinar-hero--info-strip-label">{date}</p>
        </div>
      }
      {
        time &&
        <div className="webinar-hero--info-strip-item">
          <div className="webinar-hero--info-strip-icon"><WebsiteImage src={iconTime} /></div>
          <p className="webinar-hero--info-strip-label">{`${time} (pst)`}</p>
        </div>
      }
      {
        duration &&
        <div className="webinar-hero--info-strip-item">
          <div className="webinar-hero--info-strip-icon"><WebsiteImage src={iconDuration} /></div>
          <p className="webinar-hero--info-strip-label">{`Duration: ${durationStr}`}</p>
        </div>
      }
    </Container>
  );
};

export default WebinarHeroInfoStrip;
